


































































import { Component, Prop, Mixins } from "vue-property-decorator";
import TimelineProvider from "@/components/app/global/timelineComponent/timelineProvider";

@Component({
  components: {
    event: () => import("@/components/app/global/timelineComponent/event.vue")
  }
})
export default class TimelineComponent extends Mixins(TimelineProvider) {
  // Props
  @Prop({ default: 0 })
  public height!: number;

  @Prop({ default: false })
  public loadMoreOnScroll!: boolean;

  @Prop({ default: true })
  public loadMoreOnButton!: boolean;

  public async created() {
    this.initTimelineProvider();
  }

  // Getters
  public get style() {
    if (!!this.table.total && this.height) return `height:${this.height}px`;
    return null;
  }

  // Methods
  public onScrollLoadMore() {
    if (this.loadMoreOnScroll) {
      this.loadMore();
    }
  }

  public onButtonLoadMore() {
    if (this.loadMoreOnButton) {
      this.getEvents();
    }
  }

  public onScroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
    if (
      this.loadMoreOnScroll &&
      this.hasMoreEvents &&
      // @ts-ignore
      this.$refs.loadMore.$el.clientHeight + scrollTop + clientHeight >=
        scrollHeight
    ) {
      this.loadMore();
    }
  }
}
